import styled from 'styled-components';
import { DropdownMenuListItem } from '../../SimpleDropdownMenu/styles';
import { StyleColor } from '../../../utils/styles-constants';
import { ContextualMenuItemType } from '../constants';

interface ContextualMenuItemProps {
	color: string;
	hasHoverIcon: boolean;
	hasHoverLabel: boolean;
}

const StyledContextualMenuItem = styled(DropdownMenuListItem)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	text-align: left;
	height: 50px;
	color: ${(props: ContextualMenuItemProps) => props.color};
	font-size: 17px;
	letter-spacing: 0.5px;
	font-weight: 500;
	${(props: ContextualMenuItemProps) => props.hasHoverIcon && `

		.menuIconHover {
			display: none;
		}

		:hover {
			.menuIcon {
				display: none;
			}
			.menuIconHover {
				display: block;
			}
			&.${ContextualMenuItemType.Delete} .menuIconHover svg {
				color: ${StyleColor.Red};
			}
		}`

	};

	${(props: ContextualMenuItemProps) => props.hasHoverLabel && `

		.menuLabelHover {
			display: none;
		}

		:hover {
			.menuLabel {
				display: none;
			}
			.menuLabelHover {
				display: block;
			}
			&.${ContextualMenuItemType.Delete} .menuLabelHover {
				color: ${StyleColor.Red};
			}
		}`

	};
`;

interface ContextualMenuItemIconProps {
	size: number;
}

const ContextualMenuItemIcon = styled('span')`
	width: ${(props: ContextualMenuItemIconProps) => props.size}px;
	height: ${(props: ContextualMenuItemIconProps) => props.size}px;

	svg {
		height: 100%;
		width: 100%;
		fill: currentColor;
	}
`;

export {
	StyledContextualMenuItem,
	ContextualMenuItemIcon,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ContextualMenu/Item/styles.ts